
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/policy",
      function () {
        return require("private-next-pages/info/policy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/policy"])
      });
    }
  